import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clipCoupon } from '../api/coupons';

interface UseClipCouponOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useClipCoupon(options?: UseClipCouponOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (couponId: string) => clipCoupon(couponId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clipped-coupons'] });
      queryClient.invalidateQueries({ queryKey: ['coupons'] });
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
}
